import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaChartSimple } from "react-icons/fa6";
import Reports from "./index";
import ViewReport from "./view";
import EditReport from "./edit";
import { MODULE_REPORTS } from "variables/constants";

const reportsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Reports",
		basePath: "reports",
		mainComponent: <Reports />,
	    layout: "/console",	   
	    icon: <FaChartSimple className="icon-item" />,
	    subTitle:"Report",
	    viewComponent: <ViewReport />,
	    createComponent: <EditReport />,
	    editComponent: <EditReport />,
		level:4,
		moduleId: MODULE_REPORTS,
	})
]

export default reportsRoutes;